export default __webpack_public_path__ + "static/media/icons.f3e22533.png";